import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Avatar from '@material-ui/core/Avatar';
import Skeleton from 'react-loading-skeleton';
import TextField from '@material-ui/core/TextField';
import { FormField, Pagination } from '@iris-platform/iris-react-ui';
import { take } from 'ramda';
import Panel from '../Panel';
import * as utils from '../../utils';

const DEFAULT_RECORDS_PER_PAGE = 5;

const styles = () => ({
  root: {
    '& a': {
      color: '#2fb3fa',
    },
  },
  iconLeft: {
    marginRight: '0.25em',
  },
  searchTxtInput: {
    width: "100%",
  },
});

class PaginatedSearch extends Component {
  renderLoading = () => (
    <TableBody>
      {[1, 2, 3, 4, 5].map(i => (
        <TableRow key={i}>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );

  renderContent(
    data,
    match,
    classes,
    searchTxt,
    onChangeInput,
    renderEndpoints,
    formPlaceholder,
    currentPage,
    thresholdPageBtns,
    onClickPage,
    footerButton,
    totalRecords,
    isLoading,
    recordsPerPage,
    displayInstructions,
  ) {
    return (
      <div className={classes.root}>
        <TextField
          className={classes.searchTxtInput}
          label={(displayInstructions) ? formPlaceholder || "Search based on current filter" : null}
          value={searchTxt}
          id="searchTxt"
          name="searchTxt"
          onChange={onChangeInput}
          margin="normal"
          variant="outlined"
        />
        <Table>
          {isLoading
            ? this.renderLoading()
            : renderEndpoints(take(recordsPerPage, data), match)}
        </Table>

        <br />

        {footerButton && footerButton(data)}

        <div style={{ textAlign: 'center' }}>
          <Pagination
            id=""
            title="paginatedSearchPagination"
            totalRecords={totalRecords}
            recordsPerPage={recordsPerPage}
            currentPage={currentPage}
            thresholdPageBtns={thresholdPageBtns}
            onClickPage={onClickPage}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      data,
      match,
      classes,
      searchTxt,
      onChangeInput,
      renderEndpoints,
      panelTitle,
      PanelIcon,
      formPlaceholder,
      currentPage,
      thresholdPageBtns,
      onClickPage,
      footerButton,
      totalRecords,
      isLoading,
      recordsPerPage,
      displayInstructions,
    } = this.props;

    if (panelTitle) {
      return (
        <Panel
          id={`${panelTitle}Panel`}
          title={panelTitle}
          avatar={<Avatar>{PanelIcon}</Avatar>}
        >
          {this.renderContent(
            data,
            match,
            classes,
            searchTxt,
            onChangeInput,
            renderEndpoints,
            formPlaceholder,
            currentPage,
            thresholdPageBtns,
            onClickPage,
            footerButton,
            totalRecords,
            isLoading,
            recordsPerPage,
            displayInstructions,
          )}
        </Panel>
      );
    }
    return this.renderContent(
      data,
      match,
      classes,
      searchTxt,
      onChangeInput,
      renderEndpoints,
      formPlaceholder,
      currentPage,
      thresholdPageBtns,
      onClickPage,
      footerButton,
      totalRecords,
      isLoading,
      recordsPerPage,
      displayInstructions,
    );
  }
}

PaginatedSearch.defaultProps = {
  recordsPerPage: DEFAULT_RECORDS_PER_PAGE,
  displayInstructions: true,
};

PaginatedSearch.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  classes: utils.stylesToPropType(styles()).isRequired,
  searchTxt: PropTypes.string.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  renderEndpoints: PropTypes.func.isRequired,
  panelTitle: PropTypes.string,
  PanelIcon: PropTypes.element,
  formPlaceholder: PropTypes.string.isRequired,
  currentPage: PropTypes.number.isRequired,
  thresholdPageBtns: PropTypes.number.isRequired,
  onClickPage: PropTypes.func.isRequired,
  footerButton: PropTypes.func,
  totalRecords: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  recordsPerPage: PropTypes.number,
  displayInstructions: PropTypes.bool,
};

export default withStyles(styles)(PaginatedSearch);
